__turbopack_context__.v({
  "dataBadge": "Rl-Yia_dataBadge",
  "default": "Rl-Yia_default",
  "description": "Rl-Yia_description",
  "destructive": "Rl-Yia_destructive",
  "info": "Rl-Yia_info",
  "success": "Rl-Yia_success",
  "title": "Rl-Yia_title",
  "value": "Rl-Yia_value",
  "warning": "Rl-Yia_warning",
});
